import React from 'react';
import './Calender.scss';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const Calender = React.forwardRef((props,ref) => (
    <DatePicker 
        popperPlacement="top" 
        ref={ref} 
        dateFormat={"MMM dd,yyyy"} 
        minDate={props.minDate} 
        maxDate={props.maxDate} 
        selected={props.date} 
        shouldCloseOnSelect={true}
        onChange={el => props.handler(el,props.stateKey)}  
        showMonthDropdown 
        showYearDropdown 
    />
))

export const Calenders = React.forwardRef((props,ref) => (
    <DatePicker 
        popperPlacement={props.position || "top"}
        ref={ref || null} 
        customInput={props.customInput}
        dateFormat={"MMM dd,yyyy"} 
        minDate={props.minDate} 
        maxDate={props.maxDate} 
        selected={props.date} 
        shouldCloseOnSelect={true}
        onChange={el => props.handler(el,props.stateKey)}  
        showMonthDropdown 
        showYearDropdown
    />
))